const MIN_RELEVANCE_SCORE_KEY = "dr_min_relevance_score";

export function normalizeMinRelevanceScore(value: unknown): number {
  const score = typeof value === "number" ? value : Number(value);
  return Number.isFinite(score) && score >= 0 ? score : 0;
}

export function readMinRelevanceScore(): number {
  return normalizeMinRelevanceScore(window.localStorage.getItem(MIN_RELEVANCE_SCORE_KEY));
}

export function writeMinRelevanceScore(value: number): void {
  window.localStorage.setItem(MIN_RELEVANCE_SCORE_KEY, String(normalizeMinRelevanceScore(value)));
}
